import { getData } from '../utils/data';

/**
 * Header controls.
 */
export default function headerSection() {
	const html = document.getElementsByTagName('html')[0],
    headerToggler = getData(document.getElementById('header-nav'), 'toggler');

	if (headerToggler) {

		headerToggler.on('toggle', _ => {
			html.classList[headerToggler.isOpen ? 'add' : 'remove']('is-header-open');
			// if (headerToggler.isOpen) window.scrollTo(0, 0);
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js